import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, distinct, map, mergeMap } from 'rxjs/operators';
import { loadM365Ranges, loadM365RangesFailure, loadM365RangesSuccess } from './actions';
import { M365Range } from './model';
import { MspAjaxService } from 'projects/angular-clarity/src/app/services/ajax/msp-ajax.service';

@Injectable()
export class M365RangesEffects {
    loadM365Ranges$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadM365Ranges),
            distinct((action) => action.type),
            mergeMap(() =>
                this.get().pipe(
                    map((data) => loadM365RangesSuccess({ data })),
                    catchError((error) => of(loadM365RangesFailure({ error }))),
                ),
            ),
        ),
    );

    // The API returns an array of CIDR strings; wrap each in the entity model.
    private get(): Observable<M365Range[]> {
        return this.ajax
            .get<string[]>('/api/octiga/v2/msp/m365-ip-ranges')
            .pipe(map((ranges) => ranges.map((network) => ({ network }))));
    }

    constructor(
        private actions$: Actions,
        private ajax: MspAjaxService,
    ) {}
}
